<div class="verified-worker-badge-modal">
  <div>
    <mable-heading heading="h3">Verified badge</mable-heading>
    <p>
      For safety and peace of mind, independent support workers are only approved to provide services on Mable once they
      meet our
      <a
        class="link"
        (click)="learnMore()"
        >rigorous verification requirements</a
      >.
    </p>
  </div>
  <mable-button (onClick)="dismiss()">Ok, got it</mable-button>
</div>
